import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IS_CHOSEN_PUBLIC_FILE, IS_REACT_PAGE, LOGO_SRC } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { ELogoSize, LogoComponent } from 'reactApp/ui/Header/Logo/LogoComponent';

export const Logo = memo(({ white = false }: { white?: boolean }) => {
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const isBizUser = useSelector(UserSelectors.isB2BUser);
    const size = IS_CHOSEN_PUBLIC_FILE ? ELogoSize.s : ELogoSize.m;

    return <LogoComponent isPhone={isPhone} white={white} logoSrc={LOGO_SRC} isBiz={isBizUser} size={size} useRouterLink={IS_REACT_PAGE} />;
});

Logo.displayName = 'Logo';
